import { Flex, FlexProps, Link, Skeleton, Text } from '@chakra-ui/react';
import { ChatIcon } from 'ui-components/dist/ChatIcon';

export interface INoteBlockProps extends FlexProps {
  note: string;
}

export const NoteBlock: React.FC<INoteBlockProps> = ({
  note,
  ...flexProps
}) => {
  const renderNoteWithLinks = (text: string) => {
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        // Add http:// prefix if the URL starts with www.
        const href = part.startsWith('www.') ? `http://${part}` : part;

        return (
          <Link
            key={index}
            href={href}
            target="_blank"
            color="primary.500"
            textDecoration="underline"
          >
            {part}
          </Link>
        );
      }
      return part;
    });
  };

  if (status === 'loading') {
    return (
      <Skeleton
        borderRadius="md"
        height={12}
        width="100%"
        startColor="primary.50"
        endColor="primary.100"
      />
    );
  }

  return (
    <Flex
      alignItems="flex-start"
      flexWrap="wrap"
      gap={4}
      padding={4}
      borderRadius="md"
      backgroundColor="tertiary.50"
      {...flexProps}
    >
      <ChatIcon boxSize={4} />
      <Text
        flex={1}
        margin={0}
        color="tertiary.900"
        fontSize="md"
        lineHeight={4}
        whiteSpace={'pre-wrap'}
        minWidth={0}
      >
        {renderNoteWithLinks(note)}
      </Text>
    </Flex>
  );
};
